import styled from '@emotion/styled'
import { useState } from 'react'
import Button from '~/components/Button'
import { SiteMappingAdunitView } from './SiteMappingAdunitView'
import { SiteMappingBidderView } from './SiteMappingBidderView'

const Menu = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 0px 26px 0px;
  gap: 8px;
  ${Button} {
    border-radius: 32px;
    font-weight: 400;
    padding: 6px 10px;
  }
`

export const SiteMapping: React.FunctionComponent = () => {
  const [isBidderView, setIsBidderView] = useState(true)

  return (
    <>
      <Menu>
        Display mapping by
        <Button variant={isBidderView ? 'primary' : 'tertiary'} onClick={() => setIsBidderView(true)} trackingLabel={'adm-sites-stacks-mapping-by-bidders-apply'}>
          Bidders
        </Button>
        <Button variant={!isBidderView ? 'primary' : 'tertiary'} onClick={() => setIsBidderView(false)} trackingLabel={'adm-sites-stacks-mapping-by-ad-units-apply'}>
          Ad units
        </Button>
      </Menu>

      {isBidderView ? <SiteMappingBidderView /> : <SiteMappingAdunitView />}
    </>
  )
}
